export default __webpack_public_path__ + "mytributes/images/background.jpg";